// extracted by mini-css-extract-plugin
module.exports = {"listWrapper":"style-module--listWrapper--2mskz","listItem":"style-module--listItem--JsQAu","contact":"style-module--contact--2iPBX"};